export default class Newsletter {
    
    constructor() {
        this.toggle = $('.newsletter-toggle');
        this.wrapper = $('.newsletter-signup-wrapper');
        this.close = $('.newsletter-close');
        this.form = $('.newsletter-form');
        this.nav = $('.subnav');
        this.setEventListeners();
    }

    setEventListeners() {
        this.form.on('submit', (e) => this.submitForm(e));
        this.toggle.unbind('click').on('click', () => this.toggleForm());
        this.close.unbind('click').on('click', () => this.toggleForm());
    }

    toggleForm() {
        this.wrapper.toggleClass('show');
        if (this.wrapper.hasClass('show')) {
            this.wrapper.find('[type="email"]').focus();
            this.removeResponse();
        } else {
            setTimeout(() => {
                this.removeResponse();
            }, 200);
        }
    }

    // Submit form via ajax
    submitForm(e) {
        e.preventDefault();
        let self = this;
        let form = $(e.target);
        form.find('.icon-right-angle').hide();
        form.find('.newsletter-spinner').show();

        $.ajax({
            url: form.attr('action'),
            type: 'POST',
            dataType: 'json',
            data: form.serialize(),
            success: function(data) {
                form.find('.icon-right-angle').show();
                form.find('.newsletter-spinner').hide();
                if (data.success) {
                    self.showResponse(form, 'success', data.message, true);
                }
                else {
                    self.showResponse(form, 'error', data.message, false);
                }
            }
        });
    }

    // Show response from server
    showResponse(form, type, message, fadeOut = false) {
        this.removeResponse();

        let self = this;
        let response = $("<div></div>");
        response.addClass('newsletter-response');
        response.html('<p>' + message + '</p>');
        response.insertAfter(form);
        setTimeout(() => {
            response.addClass(type);
        }, 200);

        if (fadeOut) {
            setTimeout(() => {
                this.close.trigger('click');
                response.removeClass('error success');
                setTimeout(() => {
                    self.removeResponse();
                }, 200);
            }, 2000);
        }
    }

    removeResponse() {
        $(document).find('.newsletter-response').remove();
    }
}


// WEBPACK FOOTER //
// ./public/js/Newsletter.js